export default class ActivityLightbox {
    constructor($el) {
        this.$el = $el;
        this.$modal = $el.querySelector('[data-activity-lightbox-modal]');
        this.$triggers = [...$el.querySelectorAll('[data-activity-lightbox-trigger]')];
        this.$items = this.$modal ? [...this.$modal.querySelectorAll('[data-activity-lightbox-item]')] : [];
        this.$previous = this.$modal?.querySelector('[data-activity-lightbox-prev]') || null;
        this.$next = this.$modal?.querySelector('[data-activity-lightbox-next]') || null;
        this.$closeButtons = this.$modal ? [...this.$modal.querySelectorAll('[data-activity-lightbox-close]')] : [];
        this.activeIndex = 0;
        this.lastActiveElement = null;

        if (!this.$modal || !this.$triggers.length || this.$el.dataset.activityLightboxInitialized === 'true') {
            return;
        }

        this.$el.dataset.activityLightboxInitialized = 'true';
        document.body.appendChild(this.$modal);

        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
        this.show = this.show.bind(this);
        this.showNext = this.showNext.bind(this);
        this.showPrevious = this.showPrevious.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onTransitionEnd = this.onTransitionEnd.bind(this);

        this.$triggers.forEach(($trigger, index) => {
            $trigger.addEventListener('click', (event) => {
                event.preventDefault();
                this.open(index);
            });
        });

        this.$previous?.addEventListener('click', this.showPrevious);
        this.$next?.addEventListener('click', this.showNext);
        this.$closeButtons.forEach(($button) => $button.addEventListener('click', this.close));
    }

    open(index = 0) {
        this.lastActiveElement = document.activeElement instanceof HTMLElement ? document.activeElement : null;
        this.$modal.hidden = false;
        document.body.classList.add('has-activity-lightbox');
        document.addEventListener('keydown', this.onKeyDown);
        this.show(index);
        window.requestAnimationFrame(() => {
            this.$modal.classList.add('is-open');
        });
        this.$modal.querySelector('.activity-lightbox__close')?.focus();
    }

    close() {
        this.$modal.classList.remove('is-open');
        document.body.classList.remove('has-activity-lightbox');
        document.removeEventListener('keydown', this.onKeyDown);
        this.$modal.addEventListener('transitionend', this.onTransitionEnd, {once: true});
        this.lastActiveElement?.focus();
    }

    show(index) {
        const nextIndex = (index + this.$items.length) % this.$items.length;
        this.activeIndex = nextIndex;

        this.$items.forEach(($item, itemIndex) => {
            const isActive = itemIndex === nextIndex;
            $item.hidden = !isActive;
            $item.classList.toggle('is-active', isActive);
        });
    }

    showNext() {
        this.show(this.activeIndex + 1);
    }

    showPrevious() {
        this.show(this.activeIndex - 1);
    }

    onKeyDown(event) {
        if (event.key === 'Escape') {
            this.close();
            return;
        }

        if (event.key === 'ArrowRight' && this.$items.length > 1) {
            this.showNext();
            return;
        }

        if (event.key === 'ArrowLeft' && this.$items.length > 1) {
            this.showPrevious();
        }
    }

    onTransitionEnd(event) {
        if (event.target !== this.$modal) {
            return;
        }

        if (!this.$modal.classList.contains('is-open')) {
            this.$modal.hidden = true;
        }
    }
}
